module.exports = __webpack_public_path__ + "static/media/shallow-seas-background.cffaaecc.jpg";